import { Form } from 'react-bootstrap';
import styled from 'styled-components';

export const StyledTextarea = styled(Form)`
  .form-control {
    resize: none;
  }
`;
